<google-pay-button
  [environment]="paymentMethod.environment === 'stage' ? 'TEST' : 'PRODUCTION'"
  buttonType="short"
  buttonColor="black"
  buttonSizeMode="fill"
  [buttonRadius]="0"
  [paymentRequest]="paymentRequest"
  (loadpaymentdata)="loadPaymentData($any($event).detail)">
</google-pay-button>
